import { render } from "./kdsOnItemSet.vue?vue&type=template&id=17cdef50"
import script from "./kdsOnItemSet.vue?vue&type=script&lang=js"
export * from "./kdsOnItemSet.vue?vue&type=script&lang=js"

import "./kdsOnItemSet.vue?vue&type=style&index=0&id=17cdef50&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__